















































































































































































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import { TextOutput } from '~/mixins';
import ProductSupply from '~/components/Store/ProductSupply.vue';
import { IGameItemForSaleByGala } from '~/store/games/types';
import CountdownTimerWithMessage from '~/components/UIComponents/CountdownTimerWithMessage.vue';
const _debounce = require('lodash.debounce');

@Component({ components: { CountdownTimerWithMessage, ProductSupply } })
export default class CheckoutItemDetails extends Mixins(TextOutput) {
  @Prop(Object) item!: IGameItemForSaleByGala;
  @Prop(Number) quantity!: number;
  @Prop(String) galaTagName!: string;
  @Prop(Boolean) isGalaTagToken!: boolean;

  selectedImage: {
    url: string;
    caption: string;
    hasAudio?: boolean;
  } | null = null;
  isVideoLoading = false;
  verticalThumbnailScroll = 0;
  scrolling: any = null;

  debounceHandler = _debounce((cb: Function) => {
    cb();
  }, 500);

  get rarityData() {
    return this.item ? this.item.rarity : undefined;
  }

  get imageUrl() {
    return this.selectedImage?.url || this.item?.images[0].url || '';
  }

  get imageCaption() {
    return this.selectedImage?.caption || this.item?.images[0].caption || '';
  }

  get hasAudio() {
    return (
      this.selectedImage?.hasAudio || this.item?.images[0]?.hasAudio || false
    );
  }

  get isMP4() {
    return this.imageUrl.endsWith('.mp4');
  }

  get soldOut() {
    return this.item.qtyLeft === 0;
  }

  get completelySoldOut() {
    if (this.item.tiers) {
      return (
        this.item.currentTier === this.item.tiers.length &&
        this.item.qtyLeft === 0
      );
    }

    return this.item.qtyLeft === 0;
  }

  get tierSoldOut() {
    if (this.item.tiers) {
      return (
        this.item.currentTier !== this.item.tiers.length &&
        this.item.qtyLeft === 0
      );
    }

    return false;
  }

  recaptureScrollPosition() {
    this.debounceHandler(() => {
      if (this.$vuetify.breakpoint.mdAndUp) {
        const scrollableContainer = this.$refs[
          'store-image-scrollable-thumbnails'
        ] as any;
        scrollableContainer.scroll({
          top: this.verticalThumbnailScroll,
          behavior: 'smooth',
        });
      }
    });
  }

  scrollUpThumbnailColor() {
    return this.verticalThumbnailScroll > 0 ? '#ffffff' : '#2b2b30';
  }

  scrollDownThumbnailColor() {
    const scrollableContainer = this.$refs[
      'store-image-scrollable-thumbnails'
    ] as any;
    if (scrollableContainer) {
      const scrollableHeight = scrollableContainer.scrollHeight;
      const visibleHeight = scrollableContainer.offsetHeight;
      return this.verticalThumbnailScroll <= scrollableHeight - visibleHeight
        ? '#ffffff'
        : '#2b2b30';
    } else {
      return '#ffffff';
    }
  }

  scrollUpThumbnails() {
    const scrollableContainer = this.$refs[
      'store-image-scrollable-thumbnails'
    ] as any;
    const scrollableHeight = scrollableContainer.scrollHeight;

    if (this.verticalThumbnailScroll >= 0) {
      this.verticalThumbnailScroll -= 40;
      scrollableContainer.scroll({
        top: this.verticalThumbnailScroll,
        behavior: 'smooth',
      });
    }

    this.scrolling = setInterval(() => {
      if (this.verticalThumbnailScroll > 0) {
        this.verticalThumbnailScroll -= 40;
        scrollableContainer.scroll({
          top: this.verticalThumbnailScroll,
          behavior: 'smooth',
        });
      }
    }, 100);
  }

  scrollDownThumbnails() {
    const scrollableContainer = this.$refs[
      'store-image-scrollable-thumbnails'
    ] as any;
    const scrollableHeight = scrollableContainer.scrollHeight;
    const visibleHeight = scrollableContainer.offsetHeight;

    if (this.verticalThumbnailScroll <= scrollableHeight - visibleHeight) {
      this.verticalThumbnailScroll += 40;
      scrollableContainer.scroll({
        top: this.verticalThumbnailScroll,
        behavior: 'smooth',
      });
    }

    this.scrolling = setInterval(() => {
      if (this.verticalThumbnailScroll < scrollableHeight - visibleHeight) {
        this.verticalThumbnailScroll += 40;
        scrollableContainer.scroll({
          top: this.verticalThumbnailScroll,
          behavior: 'smooth',
        });
      }
    }, 100);
  }

  scrollStop() {
    clearInterval(this.scrolling);
  }
}
